module.exports = __webpack_public_path__ + "img/posture.7e556601.png";